import React from 'react';
import './VideoMVP.css';

const VideoMVP = () => {
  return (
    <section id="video-mvp" className="video-section">
      <div className="container">
        <div className="video-container">
          <div className="mockup-container">
            <div className="iphone-mockup">
              <div className="iphone-frame">
                <div className="iphone-notch"></div>
                <div className="iphone-screen">
                  <div className="video-wrapper">
                    <video autoPlay loop muted playsInline controls poster="/assets/images/video-thumbnail.jpg">
                      <source src="/assets/image/mvp.mp4" type="video/mp4" />
                      Seu navegador não suporta a tag de vídeo.
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="video-description">
            <span className="section-eyebrow video-eyebrow">Produto</span>
            <h2>Conheça Nosso MVP</h2>
            <div className="video-features">
              <div className="video-feature">
                <i className="fas fa-check"></i>
                <span>Interface intuitiva e fácil de usar</span>
              </div>
              <div className="video-feature">
                <i className="fas fa-check"></i>
                <span>Cadastro rápido de animais</span>
              </div>
              <div className="video-feature">
                <i className="fas fa-check"></i>
                <span>Controle completo do calendário vacinal</span>
              </div>
              <div className="video-feature">
                <i className="fas fa-check"></i>
                <span>Alertas automáticos para vacinas</span>
              </div>
              <div className="video-feature">
                <i className="fas fa-check"></i>
                <span>Rastreabilidade em tempo real</span>
              </div>
              <div className="video-feature">
                <i className="fas fa-check"></i>
                <span>Relatórios detalhados e exportáveis</span>
              </div>
            </div>
            
            <a href="#planos" className="btn">Experimente Agora</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoMVP;